export default defineNuxtRouteMiddleware(async () => {
	const route = useRoute()
	const localePath = useLocalePath()
	const locale = usei18nService()?.getLocaleLang()
	const locationURLSlug = route.params.urlSlug

	try {
		const { data } = await ApiService.fetchCMSLocationBySlug(locationURLSlug, locale, true)
		if (data?.[`isActive${locale.toUpperCase()}`] === false) {
			navigateTo(localePath('/'))
		}
	} catch (error) {
		navigateTo(localePath('/'), { redirectCode: 301 })
	}
})
